/**
 * Questionnaire Type Utilities
 * 
 * Utilities for mapping and working with questionnaire types
 */

import { QuestionnaireType } from '../types/conversation.types';

/**
 * Map node type from backend to questionnaire type
 * 
 * @param nodeType - The node type from the backend message
 * @returns The corresponding questionnaire type, or null if no mapping exists
 */
export function mapNodeTypeToQuestionnaireType(nodeType: string): QuestionnaireType | null {
  const mapping: Record<string, QuestionnaireType> = {
    "persona_node": "persona",
    "problem_statement_node": "problem_statement",
    "survey_question_node": "survey_question",
    "interview_question_node": "interview_question",
    "journey_map_node": "journey_map",
    "five_whys_node": "five_whys",
    "how_might_we_node": "how_might_we",
    "user_story_map_node": "user_story_map",
  };

  const normalizedNodeType = nodeType.toLowerCase().replace(/[-_\s]/g, '');
  
  for (const [key, value] of Object.entries(mapping)) {
    const normalizedKey = key.toLowerCase().replace(/[-_\s]/g, '');
    if (normalizedKey === normalizedNodeType) {
      return value;
    }
  }

  return null;
}
